import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Inject } from '@angular/core';
import { UserService } from '../services/user.service';
import { SweetAlertService } from '../services/sweet-alert.service';
import { environment } from '../../environments/environment';
import { MsalService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-verify-passport',
  templateUrl: './verify-passport.component.html',
  styleUrls: ['./verify-passport.component.scss']
})
export class VerifyPassportComponent implements OnInit {
  // Configuration from environment
  private readonly CLIENT_ID = environment.passportVerification.clientId;
  private readonly REDIRECT_URI = environment.passportVerification.redirectUri;
  private readonly AUTH_URL = environment.passportVerification.authUrl;
  private readonly SCOPE = environment.passportVerification.scope;
  verificationFailed = false;
  verificationSuccess = false;


  // Section expansion states
  sections = {
    secure: true,
    required: false,
    privacy: false,
    storage: false,
    security: false
  };

  constructor(
    private userService: UserService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalService: MsalService,
    private spinner: NgxSpinnerService,
    private sweetAlertService: SweetAlertService
  ) {}

  consentChecked = false;


  toggleSection(sectionName: string): void {
    if (this.sections.hasOwnProperty(sectionName)) {
      this.sections[sectionName as keyof typeof this.sections] = !this.sections[sectionName as keyof typeof this.sections];
    }
  }

  ngOnInit() {
    // Check if we're returning from OAuth callback
    this.handleCallback();



  }

  startAuthFlow() {
    this.spinner.show();
    this.verificationFailed = false;

    // Generate state parameter for security
    const state = this.generateRandomString(32);
    localStorage.setItem('oauth_state', state);

    // Generate code verifier and challenge for PKCE (if supported)
    const codeVerifier = this.generateRandomString(64);
    localStorage.setItem('code_verifier', codeVerifier);

    // Build authorization URL
    const params = new URLSearchParams({
      response_type: 'code',
      client_id: this.CLIENT_ID,
      redirect_uri: this.REDIRECT_URI,
      scope: this.SCOPE,
      state: state,
      provider: 'passport-reader',
      // Add code_challenge if PKCE is required
      // code_challenge: this.generateCodeChallenge(codeVerifier),
      // code_challenge_method: 'S256'
    });

    const authUrl = `${this.AUTH_URL}?${params.toString()}`;

    // Redirect to authorization server
    window.location.href = authUrl;
  }

  private handleCallback() {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    const error = urlParams.get('error');

    if (error) {
      this.showErrorModal('Authentication Error', `Authentication error: ${error}`);
      return;
    }


    if (code && state) {



      this.sendCodeToBackend(code);
    }
  }
  signOutAzureB2C() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      this.msalService.logoutPopup({
        mainWindowRedirectUri: "/login"
      });
    } else {
      this.msalService.logoutRedirect();
    }
  }



  clearError() {
    this.verificationFailed = false;
    this.verificationSuccess = false;
  }


  // Helper method to show error modal
  private showErrorModal(title: string, message: string, icon: 'error' | 'warning' = 'error') {
    return icon === 'error'
      ? this.sweetAlertService.error(title, message)
      : this.sweetAlertService.warning(title, message);
  }


  private generateRandomString(length: number): string {
    const array = new Uint8Array(length);
    crypto.getRandomValues(array);
    return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
  }

   private sendCodeToBackend(code: string) {
    this.spinner.show();

    this.userService.verify(code).subscribe({
      next: response => {
        if(response.result && response.item){
          this.verificationSuccess = true;
        }else{
          this.verificationFailed = true;
        }

        this.spinner.hide();
      },
      error: (error: HttpErrorResponse) => {
        console.error('Verification error:', error);


        this.spinner.hide();


        if (error.status === 400) {

          this.showErrorModal(
            'Bad Request',
            'The verification request was invalid. Please try again with a valid code.'
          );
        } else {

          this.showErrorModal(
            'Error',
            'Failed to verify passport. Please contact the administrator for assistance.'
          );
        }
        this.verificationFailed = true;
      }
    });


  }
}
